<script context="module" lang="ts">
  declare var Reemo: any;
</script>

<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  // Alex's Awesome Debugger
  import { isLoading, connected } from './stores';

  const dispatch = createEventDispatcher();

  async function disconnect(dispatchMessage = true) {
    $isLoading = true;

    if (dispatchMessage) {
      dispatch('message', {
        event: 'connect',
        value: false,
      });
    }
  }
</script>

<div class="vms">
  <!-- {#if $connected}
    <button on:click={() => disconnect()}>disconnect</button>
  {/if} -->
</div>

<style>
  .vms {
    top: 0;
    left: 0;
    position: fixed;
    z-index: 2000;
    touch-action: none;
  }
</style>
